// Google Analytics 4 (GA4) implementation
export const GA_MEASUREMENT_ID = process.env.NEXT_PUBLIC_GA_ID || '';

// Initialize GA4 script (to be used in _document.js)
export const GA_SCRIPT = `
  window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}
  gtag('js', new Date());
  gtag('config', '${GA_MEASUREMENT_ID}', {
    page_path: window.location.pathname,
    debug_mode: ${process.env.NODE_ENV === 'development' ? 'true' : 'false'}
  });
`;

// Track page views
export const pageview = (url) => {
  if (!GA_MEASUREMENT_ID || !window.gtag) return;
  window.gtag('config', GA_MEASUREMENT_ID, {
    page_path: url,
  });
};

// Track events (for interaction tracking)
export const event = ({ action, category, label, value }) => {
  if (!GA_MEASUREMENT_ID || !window.gtag) return;
  window.gtag('event', action, {
    event_category: category,
    event_label: label,
    value: value,
  });
};

// E-commerce Events for Stripe Purchases
export const purchaseEvent = ({
  transaction_id,
  value,
  currency,
  items,
  plan_type,
  interval
}) => {
  if (!GA_MEASUREMENT_ID || !window.gtag) return;
  
  window.gtag('event', 'purchase', {
    transaction_id,
    value,
    currency,
    items,
    plan_type,
    interval
  });
};

// Track subscription started
export const trackSubscriptionStarted = ({
  plan_type,
  interval,
  value,
  transaction_id
}) => {
  if (!GA_MEASUREMENT_ID || !window.gtag) return;
  
  // Track overall event
  window.gtag('event', 'subscription_started', {
    plan_type,
    interval,
    value
  });
  
  // Also track as purchase event for e-commerce tracking
  purchaseEvent({
    transaction_id,
    value,
    currency: 'USD',
    items: [{
      item_id: `${plan_type}-${interval}`,
      item_name: `${plan_type} Plan (${interval})`,
      price: value
    }],
    plan_type,
    interval
  });
};

// Track subscription canceled
export const trackSubscriptionCanceled = ({
  plan_type,
  interval
}) => {
  if (!GA_MEASUREMENT_ID || !window.gtag) return;
  
  window.gtag('event', 'subscription_canceled', {
    plan_type,
    interval
  });
};

// Track subscription changed
export const trackSubscriptionChanged = ({
  old_plan_type,
  new_plan_type,
  old_interval,
  new_interval,
  value
}) => {
  if (!GA_MEASUREMENT_ID || !window.gtag) return;
  
  window.gtag('event', 'subscription_changed', {
    old_plan_type,
    new_plan_type,
    old_interval,
    new_interval,
    value
  });
};

// Track lead generation
export const trackLeadGenerated = ({ 
  contractor_id, 
  contractor_name,
  lead_type,
  location
}) => {
  if (!GA_MEASUREMENT_ID || !window.gtag) return;
  
  window.gtag('event', 'lead_generated', {
    contractor_id,
    contractor_name,
    lead_type,
    location
  });
};

// Track contractor search
export const trackSearch = ({
  query,
  location,
  results_count
}) => {
  if (!GA_MEASUREMENT_ID || !window.gtag) return;
  
  window.gtag('event', 'search', {
    search_term: query,
    location,
    results_count
  });
};

const gtagService = {
  GA_MEASUREMENT_ID,
  GA_SCRIPT,
  pageview,
  event,
  purchaseEvent,
  trackSubscriptionStarted,
  trackSubscriptionCanceled,
  trackSubscriptionChanged,
  trackLeadGenerated,
  trackSearch
};

export default gtagService;